/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e){if(e.keyCode===9){document.body.classList.add("js-using-tab");window.removeEventListener("keydown",tabClick)}}
window.addEventListener("keydown",tabClick);window.theme??={};window.theme.wrapRteTables=(rootElement=document)=>{const wrapTable=(el,wrapper)=>{el.parentNode.insertBefore(wrapper,el);wrapper.appendChild(el)};rootElement.querySelectorAll(".rte table").forEach((table=>{if(table.closest(".js-theme-utility-rte-table-wrap"))return;const tableWrapper=document.createElement("div");tableWrapper.classList.add("js-theme-utility-rte-table-wrap");tableWrapper.setAttribute("style","overflow:auto;-webkit-overflow-scrolling:touch");wrapTable(table,tableWrapper)}))};window.theme.wrapRteTables();const scrollEndSupported=typeof window==="undefined"?!0:"onscrollend" in window;if(!scrollEndSupported){import("scrollyfills")}

document.addEventListener('DOMContentLoaded', () => {
  /* ---------- STICKY ATC CREATION ---------- */
  const mainBtn = document.querySelector('.product-form button[type="submit"]');
  if (!mainBtn) return;

  const form = mainBtn.closest('form');
  if (!form) return;

  const stickyBar = document.createElement('div');
  stickyBar.className = 'sticky-atc-bar';

  const stickyBtn = document.createElement('button');
  stickyBtn.type = 'button';
  stickyBtn.className = 'sticky-atc-button';

  // Clone full inner HTML so loading spinner / checkmark are identical
  stickyBtn.innerHTML = mainBtn.innerHTML;

  stickyBar.appendChild(stickyBtn);
  document.body.appendChild(stickyBar);

  /* Mirror basic visual styles of main button */
  const mainStyles = window.getComputedStyle(mainBtn);
  stickyBtn.style.backgroundColor = mainStyles.backgroundColor;
  stickyBtn.style.color = mainStyles.color;
  stickyBtn.style.borderRadius = mainStyles.borderRadius;
  stickyBtn.style.border = mainStyles.border;
  stickyBtn.style.fontFamily = mainStyles.fontFamily;
  stickyBtn.style.fontSize = mainStyles.fontSize;
  stickyBtn.style.fontWeight = mainStyles.fontWeight;
  stickyBtn.style.lineHeight = mainStyles.lineHeight;
  stickyBtn.style.padding = mainStyles.padding;

  /* CLICK: delegate to real ATC so theme JS handles loading/checkmark */
  stickyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (mainBtn.disabled) return;
    mainBtn.click();
  });

  /* Keep inner content + disabled state in sync with main button */
  const sync = () => {
    // Mirror inner content (spinner, checkmark, text)
    stickyBtn.innerHTML = mainBtn.innerHTML;

    // Disabled state
    stickyBtn.disabled = mainBtn.disabled;
  };

  sync();

  new MutationObserver(sync).observe(mainBtn, {
    attributes: true,
    childList: true,
    subtree: true
  });

  /* ---------- VISIBILITY CONTROL (same logic you had before) ---------- */

  let lastIntersectionEntry = null;
  let forceHide = false; // when drawer/quick shop is open

  const applyVisibility = () => {
    if (forceHide) {
      stickyBar.style.display = 'none';
      return;
    }

    if (!lastIntersectionEntry) return;

    // Show only when main ATC not in view
    stickyBar.style.display = lastIntersectionEntry.isIntersecting ? 'none' : 'block';
  };

  /* Observe main button position */
  const io = new IntersectionObserver(([entry]) => {
    lastIntersectionEntry = entry;
    applyVisibility();
  });
  io.observe(mainBtn);

  const isActuallyVisible = (el) => {
    if (!el) return false;
    if (el.closest('[aria-hidden="true"]')) return false;

    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  /* QUICK SHOP check */
  const quickShopOpen = () => {
    const wrappers = document.querySelectorAll('.quick-shop__wrapper');
    for (const w of wrappers) {
      if (isActuallyVisible(w)) return true;
    }
    return false;
  };

  /* CART DRAWER / MODAL check */
  const cartDrawerOpen = () => {
    const drawers = document.querySelectorAll(
      'cart-drawer, .cart-drawer, #CartDrawer, [data-cart-drawer], .drawer--cart, .cart-modal'
    );
    for (const d of drawers) {
      if (isActuallyVisible(d)) return true;
    }

    const dialogs = document.querySelectorAll('[role="dialog"], [aria-modal="true"]');
    for (const d of dialogs) {
      if (isActuallyVisible(d)) return true;
    }

    if (
      document.body.classList.contains('drawer--is-open') ||
      document.body.classList.contains('js-drawer-open') ||
      document.body.classList.contains('cart-drawer--open') ||
      document.body.classList.contains('modal-open') ||
      document.body.style.overflow === 'hidden'
    ) {
      return true;
    }

    return false;
  };

  const refreshSticky = () => {
    forceHide = quickShopOpen() || cartDrawerOpen();
    applyVisibility();
  };

  const mo = new MutationObserver(refreshSticky);
  mo.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'class', 'style', 'aria-hidden', 'aria-modal']
  });

  document.addEventListener(
    'click',
    (e) => {
      const quickViewTrigger = e.target.closest(
        '[data-quick-view], .quick-view-button, .quickview-button, .product-card__quickview, .card__quickview, .js-view-details'
      );
      const cartTrigger = e.target.closest(
        '.site-header__cart, .header__icon--cart, [data-cart-toggle], [data-drawer-id="cart"], .js-cart-toggle'
      );

      if (quickViewTrigger || cartTrigger) {
        forceHide = true;
        applyVisibility();
        setTimeout(refreshSticky, 60);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      if (
        e.target.closest(
          '.quick-shop__wrapper .modal__close, [data-a11y-dialog-hide], [data-drawer-close], .cart-drawer__close, .drawer__close'
        )
      ) {
        setTimeout(refreshSticky, 60);
      }
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setTimeout(refreshSticky, 60);
  });

  refreshSticky();
  const poll = setInterval(refreshSticky, 500);
  window.addEventListener('pagehide', () => clearInterval(poll));
});

/* ✅ Hide Sticky Add to Cart when user scrolls below the fold, show it again above */
window.addEventListener('scroll', () => {
  const stickyBar = document.querySelector('.sticky-atc-bar');
  if (!stickyBar) return;

  const scrolledPastFold = window.scrollY > window.innerHeight * 1.0;

  if (scrolledPastFold) {
    stickyBar.classList.add('sticky-atc--fold-hidden');
  } else {
    stickyBar.classList.remove('sticky-atc--fold-hidden');
  }
});

/* ✅ Hide Sticky Add to Cart when user scrolls below the fold for checkout bar */
window.addEventListener('scroll', () => {
  const stickyBar = document.querySelector('.sticky-checkout-bar');
  if (!stickyBar) return;
  const scrolledPastFold = window.scrollY > window.innerHeight * 0.8; // adjust 0.8 to 1.0 for exact fold
  stickyBar.classList.toggle('sticky-atc--hidden', scrolledPastFold);
});
